<section class="tokenomics pageHeight" id="tokenomics">

    <h2 class="section-title m-0">{{ "tokenomics.title" | translate}}</h2>
    <h3 class="section-desc fw-semibold">{{ "tokenomics.subtitle" | translate}}</h3>
    <div class="contents d-flex gap-2">
        <img src="/assets/images/png/tokenomics-left.png" class="d-none d-md-block" alt="Tokenomics Graphics">

        <div class="box-container gap-3">
            <div class="box-content" *ngFor="let item of tokenomicsList">
                <div class="title text-uppercase fw-bold mb-1">{{ item.title | translate}}</div>
                <div class="desc font-14">{{ item.desc | translate}}</div>
            </div>
            <a href="/assets/documents/whitepaper.pdf" target="_blank"  class="d-flex justify-content-start align-items-center">
                <button class="btn w-auto white-paper font-secondary font-16 fw-semibold text-capitalize">{{"tokenomics.read_whitepaper"  | translate}}</button>
            </a>
        </div>
    </div>
    <div class="drop-shadow d-lg-inline-block d-none">
        <a  routerLink="/{{currentLanguage}}"  fragment="faq" (click)="navigateToPage('faq')"  class="btn btn-primary animation py-3 font-20 fw-semibold any-questions">{{"tokenomics.any_questions" | translate}}</a>
    </div>
    <img src="/assets/images/gif/tokenomics-bg.gif" class="globe" alt="Rotating Globe">
        <img src="/assets/images/png/mob-line-3.png" class="img-fluid d-block d-lg-none  mob-line-bottom" alt="line" >

</section>
